<template>
  <div class="page">
    <Nav
      v-if="!isMobile"
      :disabled="!ready"
      @download="banner.goDownload()"
    ></Nav>
    <Banner
      ref="banner"
      :key="`${route.fullPath}:${linkId}`"
      :is-mobile="isMobile"
      :loading="!ready"
      :channel="channel"
      :link-id="linkId"
      :auto-open-app-store="autoOpenAppStore"
    ></Banner>
    <Footer v-if="!isMobile"></Footer>
  </div>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useRequest } from '@local-composable/request';
import Nav from './components/nav.vue';
import Banner from './components/banner.vue';
import Footer from './components/footer.vue';
import { logEvent } from '@/utils/analytics';

const mobileQuery = window.matchMedia('(max-width: 768px)');
const isMobile = ref(mobileQuery.matches);
const updateViewport = () => (isMobile.value = mobileQuery.matches);
mobileQuery.addListener(updateViewport);
onUnmounted(() => mobileQuery.removeListener(updateViewport));

const route = useRoute();
const banner = ref(null);
const linkId = ref(null);
const autoOpenAppStore = ref(false);
const ready = ref(false);
const channel = computed(() => {
  const value = route.query.channel;
  return typeof value === 'string' && value.trim() && value.length <= 64 ? value : '';
});

watch(
  () => route.fullPath,
  async (_, __, onCleanup) => {
    let cancelled = false;
    onCleanup(() => (cancelled = true));
    ready.value = false;
    linkId.value = null;
    autoOpenAppStore.value = false;
    const path = route.params.pathMatch;
    const shortCode = Array.isArray(path) ? path.join('/') : path;
    try {
      if (/^[a-zA-Z0-9]{6}$/.test(shortCode || '')) {
        const { data, error } = await useRequest(
          { url: `/v2/app_deep_link/${shortCode}` },
          { toast: false },
        ).get();
        const id = data.value?.id;
        if (!cancelled && !error.value && Number.isInteger(id) && id > 0) {
          linkId.value = id;
          autoOpenAppStore.value = data.value.auto_open_app_store === 1;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (!cancelled) ready.value = true;
    }
  },
  { immediate: true },
);

logEvent('official_uv');
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';

.page {
  position: relative;
  margin: 0 auto;
  max-width: $pc-max-width;
  min-width: $pc-main-max-width;
  background: #190c05;
}

@media (max-width: 768px) {
  .page {
    max-width: $mobile-max-width;
    min-width: $mobile-main-width;
  }
}
</style>
